import React, { Fragment, useState } from 'react'
import { SeeMoreButton } from './search/pagination'

export default function ChildLimiter({ initialCount, showMoreAmount = initialCount, childWrapper, children }) {
  const [limit, setLimit] = useState(initialCount)
  const childrenToShow = React.Children.toArray(children).slice(0, limit)
  const Wrapper = childWrapper || Fragment
  return (
    <>
      <Wrapper>{childrenToShow}</Wrapper>
      {children.length > childrenToShow.length ? (
        <SeeMoreButton
          getMore={() => {
            setLimit((prevLimit) => prevLimit + showMoreAmount)
            // The SeeMoreButton expects a promise to be returned, so rather than change
            // functionality there, we just return one to make things not break
            return Promise.resolve()
          }}
        />
      ) : null}
    </>
  )
}
